import React, { useMemo } from 'react';

import { ambienceListArray } from 'config/Filter/sectionCollection';

import { useOccupancy } from 'hooks/form/search';
import { QaIdentifier } from 'hooks/useQa';

import { Attribute } from 'proto/Accommodation/Attributes';

import ScopedAttribute from '../ScopedAttribute';
import { MetaValue } from '../Segment/__hooks/useDisabledStatus';

const Ambience = ({ disableWhen = MetaValue.NoResult }) => {
    const [occupancy] = useOccupancy();
    const hasChild = occupancy.childCount > 0;

    const ambienceAttributes = useMemo(
        () =>
            ambienceListArray.filter(
                (attribute) => !(hasChild && attribute === Attribute.AdultsOnly)
            ),
        [hasChild]
    );

    return (
        <ScopedAttribute
            attributeListArray={ambienceAttributes}
            headlineKey="TRANS-ambience"
            disableWhen={disableWhen}
            qaIdentifier={QaIdentifier.Search_Filter_Section_Ambience}
        />
    );
};

export default Ambience;
